import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import classNames from 'classnames';
import s from './ResetButton.scss';
import { ResetIcon } from '../../assets/icons/ResetIcon';
import { i18n } from '../../../../symphony';

interface ResetButtonProps {
	onClick: () => void;
	className?: string;
	disabled?: boolean;
	isLightMode?: boolean;
}

export const ResetButton: React.FC<ResetButtonProps> = ({
	onClick, className, disabled, isLightMode,
}) => {
	useStyles(s);

	return (
		<button
			type="button"
			disabled={disabled}
			className={classNames('sl-playground__reset-btn', className, {
				light: isLightMode,
			})}
			onClick={onClick}
		>
			<ResetIcon className={classNames('sl-playground__reset-btn__icon', {
				disabled,
				light: isLightMode,
			})}
			/>
			<span className="sl-playground__reset-btn__text">
				{i18n.t('code.reset-bottomsheet-title')}
			</span>
		</button>
	);
};
